import { EventFieldType } from 'types/EventField';

export const getCustomerFormValues = (
  data: any,
  customerform: EventFieldType[] | null,
  cartUUID: string,
) => {
  let customerFields = {};

  customerFields[cartUUID] = [];
  customerFields[cartUUID][0] = {};

  if (!customerform) return customerFields;

  for (let key in data) {
    if (key.split('-')[0] === 'customer') {
      const fieldIndexInCustomerForm = customerform.findIndex(
        ({ id }) => id === key.split('-')[1],
      );
      if (customerform[fieldIndexInCustomerForm].type === 'select') {
        // if select is empty
        if (!data[key]) {
          customerFields[cartUUID][0][key.split('-')[1]] = [];
        } else if (Array.isArray(data[key])) {
          // if select has multiple select activated
          let indexes: number[] = [];
          for (let i = 0; i < data[key].length; i++) {
            const indexOfSelectValue = customerform[
              fieldIndexInCustomerForm
            ].meta.options.findIndex(option => option === data[key][i].value);
            indexes.push(indexOfSelectValue);
          }
          customerFields[cartUUID][0][key.split('-')[1]] = [...indexes];
        } else {
          if (data[key].value) {
            const indexOfSelectValue = customerform[
              fieldIndexInCustomerForm
            ].meta.options.findIndex(option => option === data[key].value);

            customerFields[cartUUID][0][key.split('-')[1]] = [
              indexOfSelectValue,
            ];
          } else {
            customerFields[cartUUID][0][key.split('-')[1]] = [];
          }
        }
      } else {
        customerFields[cartUUID][0][key.split('-')[1]] = data[key];
      }
    }
  }

  return customerFields;
};
